// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__24WGL","colMaxWidth":"Table_colMaxWidth__3r-Jz"};